var ProductsCarousel = {};


//--------------
// Variable
//--------------

ProductsCarousel.carousel = null;
ProductsCarousel.slide = $('.js-products-carousel .swiper-slide');

/**
 * ProductsCarousel init
 * @return {void}
 */

ProductsCarousel.initCarousel = function (carousel) {
	ProductsCarousel.carousel = new App.Swiper(carousel, {
		loop: true,
		speed: 600,
		slidesOffsetBefore: 0,
		navigation: {
			nextEl: $('.js-products-carousel').find('.swiper-button-next'),
			prevEl: $('.js-products-carousel').find('.swiper-button-prev'),
		},
		centeredSlides: true,
		slidesPerView: 'auto',
		breakpoints: {
			576: {
				slidesOffsetBefore: ProductsCarousel.slide.outerWidth() / 2,
			},
		}
	});
}


//--------------
// Execution
//--------------

ProductsCarousel.init = function () {
	//-- Init Carousel
	if ($(window).outerWidth() > 991) {
		if (ProductsCarousel.slide.length > 4) {
			ProductsCarousel.initCarousel('.js-products-carousel');
		} else {
			$('.js-products-carousel').addClass('no-swiper');
		}
	}

	else if ($(window).outerWidth() > 767) {
		if (ProductsCarousel.slide.length > 3) {
			ProductsCarousel.initCarousel('.js-products-carousel');
		} else {
			$('.js-products-carousel').addClass('no-swiper');
		}
	}

	else if ($(window).outerWidth() > 575) {
		if (ProductsCarousel.slide.length > 2) {
			ProductsCarousel.initCarousel('.js-products-carousel');
		} else {
			$('.js-products-carousel').addClass('no-swiper');
		}
	}

	else if ($(window).outerWidth() < 576) {
		if (ProductsCarousel.slide.length > 1) {
			ProductsCarousel.initCarousel('.js-products-carousel');
		} else {
			$('.js-products-carousel').addClass('no-swiper');
		}
	}
}

ProductsCarousel.init();

module.exports = ProductsCarousel;
